<template>
    <h3 class="text-dark mb-4 text-2xl">
        <span class="font-bold">Top reviews</span>

        for

        <template v-if="manufacturer || model.manufacturer">
            {{ manufacturer ? manufacturer.name : model.manufacturer.name }}
        </template>

        {{ model.name }} tyres
    </h3>

    <p class="text-sm mb-4">
        The most helpful reviews as voted by our users
    </p>

    <ReviewCard v-for="review of reviews" :review="review"></ReviewCard>
</template>

<script>
import ReviewCard from "@/Components/Reviews/ReviewCard";

export default {
    components: {ReviewCard},
    props: {
        manufacturer: Object,
        model: Object,
        reviews: Array
    }
};
</script>

<style scoped>

</style>
